import ValidationState from '@/VueComponents/Uploads/models/validationState';

export default class UploadFieldValue {
  constructor(
    public fieldId: string,
    public value: string,
    public subGroupValue: string | null,
    public validationState: ValidationState
  ) { }
}